import styled, { css } from "styled-components";
import { NavLink } from "react-router-dom";
import { keyframes } from "styled-components";

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const SettingsWrapper = styled.div`
  display: flex;
  position: absolute;
  top: 97px; /* Wysokość górnej nawigacji */
  left: ${({ isInfoHub }) => (isInfoHub ? '250px' : '200px')}; /* Szerokość lewej nawigacji */
  right: 0;
  bottom: 0;
  // background-color: ${({ theme }) => theme.color.background};
  color: ${({ theme }) => theme.color.text};
  overflow-y: auto;

  @media (max-width: 969px) {
    left: 0;
    width: 100%;
    flex-direction: column;
    padding: 1rem;
    position: static;
    margin-top: 70px;
  }
    @media (max-width: 1460px) {
 left: 100px
  }
`;

export const LeftMenu = styled.nav`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  width: 250px;
  padding: 1.5rem 0 1.5rem 3rem;

  @media (max-width: 969px) {
    width: 100%;
    border-bottom: 1px solid ${({ theme }) => theme.color.border};
    padding: 0.5rem;
    margin-bottom: 1.5rem;
    flex-direction: row;
    overflow-x: auto;
  }
`;

export const MenuItem = styled(NavLink)`
  font-size: 0.95rem;
  font-weight: 500;
  padding: 0.6rem 1rem;
  margin-bottom: 0.25rem;
  text-decoration: none;
  border-radius: 6px;
  color: ${({ theme }) => theme.color.text};
  display: flex;
  align-items: center;
  gap: 0.8rem;
  position: relative;
  border: 1px solid transparent;
  transition: background 0.2s ease, color 0.2s ease;
  &:hover {
    background-color: ${({ theme }) => theme.color.spotifyLightGrey};
    color: ${({ theme }) => theme.color.spotifyWhite};
  }

  &.active {
    font-weight: 600;
    background-color: ${({ theme }) => theme.color.backgroundSecondary};
    
    &::before {
      content: '';
      position: absolute;
      left: -12px;
      top: 50%;
      transform: translateY(-50%);
      height: 24px;
      width: 3px;
      background-color: #2ea043; /* Zielony akcent */
      border-radius: 2px;
    }
  }

  @media (max-width: 969px) {
    margin-bottom: 0;
    margin-right: 0.5rem;
    white-space: nowrap;

    &.active::before {
      display: none; /* Ukryj pasek na mobilnym widoku */
    }
  }
`;

export const ContentArea = styled.main`
  flex-grow: 1;
  padding: 2.5rem 3rem;
  max-width: 1000px;
  
  @media (max-width: 969px) {
    padding: 1rem;
  }
`;

export const HorizontalLine = styled.hr`
  border: none;
  border-top: 1px solid ${({ theme }) => theme.color.border};
  margin: 1.5rem 0;
`;

export const ContentHeader = styled.h1`
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 2rem;
  animation: ${fadeIn} 0.2s ease-out forwards;
`;

export const ContentSection = styled.div`
  border-top: 1px solid ${({ theme }) => theme.color.border};
  padding-top: 1.5rem;
  animation: ${fadeIn} 0.2s ease-out forwards;
`;

export const PlanInfo = styled.div`
  padding-bottom: 1.5rem;
`;

export const PlanTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
`;

export const PlanSubtitle = styled.p`
  color: ${({ theme }) => theme.color.silver};
  font-size: 0.9rem;
`;

export const SpanPremium = styled.span`
  ${({ isPremium }) =>
    isPremium &&
    css`
      background: linear-gradient(90deg, #ffdb4d 0%, #ff8c00 100%);
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent;
    `}
`;

export const SectionTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
`;

export const SectionDescription = styled.p`
    color: ${({ theme }) => theme.color.textSecondary};
    margin-bottom: 1.5rem;
    max-width: 650px;
    font-size: 0.9rem;
    line-height: 1.6;
`;

export const ManageButton = styled.button`
  background-color: ${({ theme }) => theme.color.buttonBackground};
  color: ${({ theme }) => theme.color.buttonText};
  border: 1px solid ${({ theme }) => theme.color.border};
  padding: 0.5rem 1.2rem;
  border-radius: 6px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: ${({ theme }) => theme.color.buttonBackgroundHover};
    border-color: ${({ theme }) => theme.color.borderHover};
  }
`; 

export const ContactLink = styled.a`
      color: #fff;
    text-decoration: none;
    font-weight: 600;
    &:hover {
text-decoration: underline;
  }
`;

export const ComingSoonBadge = styled.div`
  background: linear-gradient(90deg, #ffdb4d 0%, #ff8c00 100%);
  color: #000;
  font-size: 14px;
  font-weight: 700;
  padding: 2px 4px;
  border-radius: 12px;
  z-index: 2;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  display: inline-block;
  margin-left: 15px;
  vertical-align: middle;
  transform: translateY(-2px);
`;
